import styled from 'styled-components';
import Box from 'elements/Box';

export const Footer = styled(Box)`
  flex-shrink: 0;
`;

export const Content = styled(Box)`
  flex: 1 0 auto;
`;

const Page = styled(Box)`
  height: 100%;
  padding: 0.5rem;
  margin: 0.5rem auto;
  max-width: 40rem;
  display: flex;
  flex-direction: column;
  grid-gap: 20rem;
`;

export default Page;
